/**
 * The failed-read callout the Loan Participations list pages share.
 *
 * A participant-context refusal (see read-error.ts) reads as a condition of
 * the institution's network record, with a pre-scoped support case, never
 * as the server's developer sentence. Any other failure keeps the server
 * message, which is the only description of it the page has.
 */

import { Link } from 'react-router-dom';
import { Alert } from '@aaimplatform/ui';
import { requestChangeHref } from '../../utils/request-change';
import { participantContextCopy } from './read-error';

export function ReadErrorBanner({
  error,
  subject,
  surface,
  className = 'mb-6',
}: {
  /** The query error. */
  error: unknown;
  /** What failed to load, lowercase: 'positions', 'indications of interest'. */
  subject: string;
  /** The page, for the support case: 'Loan Participations -- Positions'. */
  surface: string;
  className?: string;
}) {
  const participant = participantContextCopy(error);
  return (
    <div role="alert" className={className}>
      <Alert type="error" title={`Could not load ${subject}`}>
        {participant ? (
          <>
            {participant.reason}{' '}
            <Link
              to={requestChangeHref({
                surface,
                item: participant.supportItem,
                detail: `The ${subject} read was refused with ${participant.code}.`,
              })}
              className="text-accent hover:underline"
            >
              Open a support case
            </Link>
          </>
        ) : (
          error instanceof Error && error.message ? error.message : 'The request failed.'
        )}
      </Alert>
    </div>
  );
}
